import { Theme } from '@mui/material';

export const MuiAutocompleteStyled = (theme: Theme) => {
    theme.components = {
        ...theme.components,
        MuiAutocomplete: {
            styleOverrides: {
                root: {
                    '& .MuiAutocomplete-popper': {
                        backgroundColor: 'red',
                    },
                },
                
            },

        },
    };
};
